import { IconProps } from '@euler/app/components/icons/types';
import { GradientIconProps } from '@euler/app/tv/theme/types';
import { FC, memo } from 'react';
import Svg, { Defs, LinearGradient, Path, Stop } from 'react-native-svg';

export const FinishTimeIcon: FC<IconProps & GradientIconProps> = memo(
  ({
    width,
    height,
    size = 16,
    color = 'rgba(255, 255, 255, 0.4)',
    startColor,
    endColor,
    style,
  }) => {
    return (
      <Svg
        width={width ?? size}
        height={height ?? size}
        viewBox="0 0 16 16"
        style={style}
      >
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.7143 2.14289H14.7143C15.0304 2.14289 15.2857 2.39825 15.2857 2.71432V14.5715C15.2857 14.8875 15.0304 15.1429 14.7143 15.1429H1.57143C1.25536 15.1429 1 14.8875 1 14.5715V2.71432C1 2.39825 1.25536 2.14289 1.57143 2.14289H4.57143V1.00003C4.57143 0.921463 4.63571 0.857178 4.71429 0.857178H5.71429C5.79286 0.857178 5.85714 0.921463 5.85714 1.00003V2.14289H10.4286V1.00003C10.4286 0.921463 10.4929 0.857178 10.5714 0.857178H11.5714C11.65 0.857178 11.7143 0.921463 11.7143 1.00003V2.14289ZM2.28571 13.8572H14V7.07146H2.28571V13.8572ZM2.28571 3.42861V5.85718H14V3.42861H11.7143V4.28575C11.7143 4.36432 11.65 4.42861 11.5714 4.42861H10.5714C10.4929 4.42861 10.4286 4.36432 10.4286 4.28575V3.42861H5.85714V4.28575C5.85714 4.36432 5.79286 4.42861 5.71429 4.42861H4.71429C4.63571 4.42861 4.57143 4.36432 4.57143 4.28575V3.42861H2.28571ZM7.79082 12.4262L11.3431 9.07689L10.6571 8.3493L7.84574 11L6.37007 9.37676L5.63013 10.0494L7.79082 12.4262Z"
          fill="url(#paint0_linear_371_4141)"
        />
        <Defs>
          <LinearGradient
            id="paint0_linear_371_4141"
            x1="0.642825"
            y1="13.9999"
            x2="15.1428"
            y2="3.99998"
            gradientUnits="userSpaceOnUse"
          >
            <Stop stopColor={startColor ?? color} />
            <Stop offset="1" stopColor={endColor ?? color} />
          </LinearGradient>
        </Defs>
      </Svg>
    );
  },
);
